import { apiClient } from "@/lib/apiClient";
import { PaginatedResponse, Report, ReportFilter } from "@/types";

export const reportService = {
    getReports: async (
        page: number = 1,
        limit: number = 10,
        filters?: ReportFilter
    ): Promise<PaginatedResponse<Report>> => {
        const params: Record<string, string> = {
            page: page.toString(),
            limit: limit.toString(),
        };

        if (filters?.userPid) params.userPid = filters.userPid;
        if (filters?.priorityPid) params.priorityPid = filters.priorityPid;
        if (filters?.reportDate) params.reportDate = filters.reportDate.toISOString();
        if (filters?.blocker !== undefined) params.blocker = filters.blocker.toString();

        return apiClient.get<PaginatedResponse<Report>>("/api/reports", { params });
    },

    getReportById: async (pid: string): Promise<Report> => {
        return apiClient.get<Report>(`/api/reports/${pid}`);
    },
};
